import { isObjectStriclyEqual } from '@/lib/equality';
import type { LoadPeopleParams } from './actions/people';

export function isLoadParamsEqual(
  a: LoadPeopleParams,
  b: LoadPeopleParams,
  exclude?: (keyof LoadPeopleParams)[],
) {
  return isObjectStriclyEqual(a, b, exclude);
}
